import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import * as Common from 'common/components';

const CompaniesListHeader = ({ t = (key) => key, canAdd = false }) => {
  return (
    <Common.PageHeader title={t('companies.title')}>
      <div className="btn-group pull-right">
        <Link to={`/companies/add`} className="btn btn-info">
          {t('actions.add')}
        </Link>
      </div>
    </Common.PageHeader>
  );
};

export default translate()(CompaniesListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/components/CompaniesListHeader.js